<template>
	<StandardModal
		open
		small
		:title="$t('settings_apitokens_new_token_title')"
		@cancel="$emit('cancel')"
	>
		<div class="new-token-modal">
			<FormItem
				:label="$t('settings_apitokens_new_token_label')"
				:help="$t('settings_apitokens_new_token_help')"
			>
				<Input
					autoFocus
					class="token-input"
					maxlength="100"
					v-model="newName"
					@keyup.enter="$emit('next', newName)"
				/>
			</FormItem>
		</div>

		<template #footer-right>
			<Button primary :disabled="!newName" @click="$emit('next', newName)">
				{{ $t('common_button_next') }}
			</Button>
		</template>
	</StandardModal>
</template>

<script>
import { StandardModal, Button, Input, FormItem } from '@/components/common'

export default {
	name: 'NewToken',
	props: ['name'],
	components: { StandardModal, Button, Input, FormItem },
	data() {
		return { newName: this.name || '' }
	},
	emits: ['next', 'cancel'],
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.new-token-modal {
	display: flex;
	flex-direction: column;
	padding: 36px 24px;
}

.title {
	margin-bottom: 10px;
	font-family: 'Avenir-Black';
	font-size: 24px;
	color: var(--neutral-800);
	text-align: center;
}

.label {
	font-family: 'Avenir-Black';
	font-size: 16px;
	color: var(--neutral-800);
	margin-bottom: 8px;
}
</style>
